module.exports = __webpack_public_path__ + "media/images/CHA-05-fc550fbcd87ba9a8914143ba877f7342.jpg";